import type { ApiClient, CustomerList } from '@elite-residence/api-client';

export async function loadCustomers(
  client: ApiClient,
  query: Parameters<ApiClient['searchCustomers']>[0]['query'],
): Promise<Awaited<ReturnType<ApiClient['searchCustomers']>>> {
  const customers: CustomerList['customers'][number][] = [];
  const cursors = new Set<string>();
  let cursor: string | undefined;
  do {
    const response = await client.searchCustomers({
      query: { ...query, limit: '500', ...(cursor ? { cursor } : {}) },
    });
    // Never present the first page as complete after permission/read failure.
    if (response.status !== 200) return response;
    customers.push(...response.body.customers);
    cursor = response.body.nextCursor ?? undefined;
    if (cursor) {
      if (cursors.has(cursor)) throw new Error('customers_cursor_repeated');
      cursors.add(cursor);
    }
  } while (cursor);
  return { status: 200, body: { customers, nextCursor: null } };
}
